var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[(_vm.restaurant)?_c('site-header',{attrs:{"restaurant":_vm.restaurant}}):_vm._e(),_c('router-view'),_c('site-footer',{attrs:{"AboutCo":_vm.AboutCo,"Copyrights":_vm.CRights}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }